<template>
  <authorization permissionKey="exams_queue" can="read">
    <Attendances queueType="exams" :attendancePlaceId="attendancePlaceId">
      <template v-slot:attendance="{ attendance }">
        <MedicalRequestQueue :attendance="attendance" queueType="exams" />
      </template>
    </Attendances>
  </authorization>
</template>

<script>
import Attendances from "@/components/queues/attendances.vue";
import MedicalRequestQueue from "@/components/medical_request/queue.vue";

export default {
  name: "ExecutingExams",
  components: {
    Attendances,
    MedicalRequestQueue,
  },
  props: {
    attendancePlaceId: String,
  },
};
</script>

<style lang="scss" scoped></style>
